import React from "react";
import { useTranslation } from "react-i18next";
import AmpInput from "../AmpInput/AmpInput";
import SmallHeading from "../AmpSmallHeading/AppSmallHeading";
import RollNumberInput from "../AmpInput/RollNumberInput";
import AmpToolTip from "../AmpToolTip/AmpToolTip";

import "./RollAccessKey.css";

interface RollAccessKeyProps {
    showTooltip?: boolean;

}

export default function RollAccessKey(props: RollAccessKeyProps) : JSX.Element {

    const { showTooltip } = props;

    const { t } = useTranslation('login');
    
    return (
        <>
            <RollNumberInput showTooltip={true} />
            <SmallHeading for="access_key">{t('access-key') as string} {showTooltip &&  <AmpToolTip id="accessTooltip" content={t("access-tip") as string} direction="right"/>}</SmallHeading>
            <AmpInput type="text" id="access_key" className="access-key" name={"access-key"}/>
        </>
    )
}